import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Container, Alert } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { API_CONFIG } from '../../api/config';

const BackgroundImageContainer = styled('div')({
  backgroundImage: 'url(https://beta.visamonde.com/assets/mobile/fond.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const LoginLegrand: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');

  const handleLogin = async () => {
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_CONFIG.baseUrl}/api/legrand/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token_legrand', data.token);
        localStorage.setItem('user_legrand', JSON.stringify(data.user));
        localStorage.setItem('adresses_legrand', JSON.stringify(data.adresses_facturation));
        localStorage.setItem('emails_legrand', JSON.stringify(data.emails));
        navigate('/legrand/dashboard');
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Identifiants incorrects');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !loading) {
      handleLogin();
    }
  };

  return (
    <BackgroundImageContainer>
      <Container maxWidth="sm">
        <Paper elevation={3} style={{ padding: '30px', borderRadius: '10px' }}>
          <Box textAlign="center" mb={3}>
            <Typography variant="h5" style={{ marginBottom: '20px' }}>
              Admin VisaMonde - Legrand
            </Typography>
          </Box>

          <Box
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              required
              fullWidth
              id="username"
              label="Nom d'utilisateur"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
              variant="outlined"
            />
            <TextField
              required
              fullWidth
              id="password"
              label="Mot de passe"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
              variant="outlined"
            />

            {error && (
              <Alert severity="error" onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            <Button
              variant="contained"
              onClick={handleLogin}
              disabled={loading || !username || !password}
              fullWidth
              size="large"
              sx={{ mt: 2 }}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </Box>
        </Paper>
      </Container>
    </BackgroundImageContainer>
  );
};

export default LoginLegrand;